import { Address } from '../types/address';

const escapeRegexCharacters = (str: string) =>
  str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const getSuggestions = (
  result: Array<{ label: string }>,
  value: string
) => {
  const escapedValue = escapeRegexCharacters(value.trim());

  if (escapedValue === '') {
    return [];
  }

  const regex = new RegExp(escapedValue, 'i');
  const suggestions = result.filter(suburb => regex.test(suburb.label));

  if (suggestions.length === 0) {
    return [{ isNotFound: true }];
  }
  return suggestions;
};

export const convertCase = (lowercaseSuburb: string) =>
  lowercaseSuburb
    .split(' ')
    .reduce(
      (uppercaseSuburb, string) =>
        `${
          uppercaseSuburb +
          string.substr(0, 1).toUpperCase() +
          string.substr(1).toLowerCase()
        } `,
      ''
    )
    .trim();

export function isValidAddress(address: Address) {
  return (
    address.country !== null &&
    address.country_code !== null &&
    address.firstname !== null &&
    address.lastname !== null &&
    address.phone !== null &&
    address.postcode !== null &&
    address.region !== null &&
    address.region_code !== null &&
    address.street?.[0]?.trim() !== '' &&
    address.suburb !== null
  );
}

export const regionCodeToRegion = (regionCode: string) => {
  switch (regionCode.toUpperCase()) {
    case 'NSW':
      return 'New South Wales';
    case 'QLD':
      return 'Queensland';
    case 'SA':
      return 'South Australia';
    case 'TAS':
      return 'Tasmania';
    case 'VIC':
      return 'Victoria';
    case 'WA':
      return 'Western Australia';
    case 'NT':
      return 'Northern Territory';
    case 'ACT':
      return 'Australian Capital Territory';
    default:
      return `${regionCode} unknown`;
  }
};
